var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('span',{staticClass:"m-0 d-inline-block align-middle"},[_c('i',{staticClass:"bx bx-time align-middle gray-500"}),_c('span',{staticClass:"align-middle"},[_vm._v(" "+_vm._s(this.hours + "h" + " " + this.minutes + "m")+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }